import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Upload } from "antd";
import React, { FC, useEffect, useState } from "react";
import { Document } from "../../PreAuthIhx/PreAuthIhx";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";

type DocumentUploadProps = {
  documentTypes: Document[];
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  handleFileChange: any;
  handleOpen: any;
  portalSubmission: boolean;
  documentRequestResponseDocuments: any;
  getStarmarkOptions: any;
  uploadFileList: any;
  isIntimated: any;
};

const DocumentUpload: FC<DocumentUploadProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  portalSubmission,
  documentRequestResponseDocuments,
  getStarmarkOptions,
  uploadFileList,
  isIntimated,
}) => {
  const [updatedDocumentUrls, setUpdatedDocumentUrls] = useState<any>();
  const { auth, patients } = useSelector((state: RootState) => state);

  useEffect(() => {
    const uploadedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["requestedDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    setUpdatedDocumentUrls(uploadedDocumentUrls);
  }, [documentRequestResponseDocuments, documentUrls]);

  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          textDecoration: "underline",
          fontSize: "16px",
          margin: "16px 0",
          fontWeight: "bold",
        }}
      >
        Request Document Upload
      </div>

      {/* <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                  // padding: "15px 55px",
                  gap: 20,
                }}
              >
                {documentTypes?.map((documentType: any) => (
                  <Upload
                    id={documentType.id}
                    beforeUpload={() => false}
                    maxCount={1}
                    onChange={
                      handleFileChange &&
                      handleFileChange(documentType?.labelId)
                    }
                    showUploadList={false}
                    // disabled={isReadOnly}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ marginLeft: "10px", width: "100%" }}
                      //   disabled={isReadOnly}
                    >
                      {documentType?.label}
                    </Button>
                  </Upload>
                ))}
              </div> */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          //   opacity: !portalSubmission ? 1 : 0.5,
          //   pointerEvents: !portalSubmission ? 'auto' : 'none',
        }}
      >
        {documentRequestResponseDocuments?.["requestedDocuments"]?.length > 0 &&
          documentRequestResponseDocuments?.["requestedDocuments"]?.map(
            (docType: any) => {
              //documentTypes?.map((docType: any) => {
              const matchingDocuments = documentUrls?.filter(
                (doc) => doc.documentLabelType === docType.label
              );

              if (matchingDocuments?.length > 0 && !docType?.multiple) {
                return null;
              }

              return (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    // gap: 8,
                  }}
                >
                  {/* <div style={{ marginBottom: 8, fontWeight: "bold" }}>
                {docType.label}
              </div> */}

                  {matchingDocuments?.length > 0 && !docType?.multiple ? (
                    <p></p>
                  ) : (
                    <Upload
                      multiple={docType?.multiple}
                      {...(docType?.multiple
                        ? { fileList: uploadFileList }
                        : {})}
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={
                        handleFileChange &&
                        handleFileChange(docType?.labelId, docType?.multiple)
                      }
                      disabled={portalSubmission}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 0,
                          border: "none",
                          borderTopLeftRadius: "6px",
                          borderBottomLeftRadius: "6px",
                        }}
                        // disabled={
                        //   (auth?.role?.role === "FO_STAFF" && isIntimated) ||
                        //   portalSubmission
                        // }
                        disabled={((patients?.fetchBasicDetails?.patientResponse?.age ?? 0) >= 70 && patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() === "OP" && docType?.label?.toUpperCase() === "REFERRAL LETTER") ? true :  portalSubmission}
                      ></Button>
                    </Upload>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: 0,
                        border: "none",
                        paddingLeft: 4,
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                      iconPosition={"end"}
                      // icon={
                      //   matchingDocuments?.length > 0 ? (
                      //     <EyeOutlined
                      //       style={{ marginLeft: "0.6rem" }}
                      //       onClick={() => {
                      //         handleOpen(
                      //           matchingDocuments?.[0]?.documentLabelType
                      //         );
                      //       }}
                      //     />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    >
                      {docType.label}{" "}
                      {getStarmarkOptions().some(
                        (requiredDoc: any) =>
                          requiredDoc.label === docType?.label &&
                          (requiredDoc?.hasOwnProperty("required")
                            ? requiredDoc?.required
                            : true)
                      ) && <span style={{ color: "red" }}> *</span>}
                      {/* {docType?.required ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : (
                        <></>
                      )} */}
                    </Button>
                  </div>

                  {/* {matchingDocuments?.length > 0 && (
                // <ul style={{ marginTop: 10, paddingLeft: 0 }}>
                //   {matchingDocuments.map((doc, i) => (
                //     <li
                //       key={i}
                //       style={{
                //         listStyle: "none",
                //         display: "flex",
                //         justifyContent: "space-between",
                //         alignItems: "center",
                //         padding: "6px 0",
                //         borderBottom: "1px solid #f0f0f0",
                //       }}
                //     >
                //       <a
                //         href={doc.documentUrl}
                //         target="_blank"
                //         rel="noreferrer"
                //       >
                //         {doc.documentName || `Document ${i + 1}`}
                //       </a>
                //       <Button
                //         danger
                //         type="link"
                //         icon={<DeleteOutlined />}
                //         onClick={() =>
                //           handleDeleteList(doc.documentType, doc.documentUrl, i)
                //         }
                //       />
                //     </li>
                //   ))}
                // </ul>

                <EyeOutlined
                  style={{ marginLeft: "0.6rem" }}
                  onClick={() => {
                    handleOpen();
                  }}
                />
              )} */}
                </div>
              );
            }
          )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop:
            updatedDocumentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {Object.entries(groupByLabelType(updatedDocumentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                          docType?.deficiencyCheckStatus === false
                        ? "#DD2025"
                        : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(
                            docType?.documentLabelType,
                            docType?.documentUrl
                          );
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            ))
        )}
      </div>
    </div>
  );
};

export default DocumentUpload;
